
import { Options, Vue } from "vue-class-component";
// firebase
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { getAuth, signOut } from "firebase/auth";
// remixicon
import 'remixicon/fonts/remixicon.css'

@Options({})
export default class NavigationComponent extends Vue {
  logo: any = String();

  showMobileMenu = false;

  created() {
    const storage = getStorage();
    getDownloadURL(ref(storage, "logos/logo.png")).then((url) => {
      this.logo = url;
    });
  }

  signOut() {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        this.$router.push("/");
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
      });
  }
}
